/**
 * function to set formatNumber based on this project standard
 * @param number
 * @returns {string}
 */
export const formatNumber = (number) =>{
    return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
    });
};

/**
 * Converts a 1-based WorkOrderSequence into a spreadsheet-style alpha suffix
 * 1 -> A, 2 -> B, ..., 26 -> Z, 27 -> AA, 28 -> AB, ...
 * @param sequence
 * @returns {string}
 */
export const sequenceToAlpha = (sequence) => {
    let n = Number(sequence);
    if (!n || n < 1) return "";

    let result = "";
    while (n > 0) {
        const remainder = (n - 1) % 26;
        result = String.fromCharCode(65 + remainder) + result;
        n = Math.floor((n - 1) / 26);
    }

    return result;
};